import {
  Home,
  LogOut,
  Box,
  DollarSign,
  UserPlus,
  Users,
  Send,
  Chrome,
  Settings,
  Paperclip,
  Airplay,
  Slack,
  FolderPlus,
  File,
  Command,
  Cloud,
  Book,
  FileText,
  Server,
  Image,
  Sliders,
  Map,
  GitPullRequest,
  Calendar,
  Edit,
  Mail,
  MessageSquare,
  UserCheck,
  Layers,
  HelpCircle,
  Database,
  Headphones,
  Mic,
  ShoppingBag,
  Search,
  AlertOctagon,
  Lock,
  Briefcase,
  BarChart,
} from "react-feather";

export const MENUITEMS_ADMIN = [
  // {
  //   title: "Dashboard",
  //   icon: Home,
  //   type: "sub",
  //   active: false,
  //   children: [
  //     { path: "/dashboard/home", title: "Home", type: "link" },
  //     // { path: "/training/report", title: "Reports", type: "link" }
  //   ],
  // },
  // {
  //   title: "Dealers",
  //   icon: UserCheck,
  //   type: "sub",
  //   badgeType: "primary",
  //   active: false,
  //   children: [
  //     {
  //       path: "/dealer/all",
  //       title: "All",
  //       type: "link",
  //     },
  //     {
  //       path: "/dealer/new",
  //       title: "New",
  //       type: "link",
  //     },
  //     {
  //       path: "/dealer/deactivated",
  //       title: "Deactivated",
  //       type: "link",
  //     },
  //   ],
  // },

  // {
  //   title: "Staff Members",
  //   customIcon: true,
  //   icon: "icofont icofont-worker",
  //   type: "sub",
  //   active: false,
  //   children: [
  //     {
  //       path: "/staff-members/add",
  //       title: "Add Member",
  //       type: "link",
  //     },
  //     { path: "/staff-members/all", title: "All Members", type: "link" },
  //     {
  //       path: "/staff-members/activated",
  //       title: "Activated Members",
  //       type: "link",
  //     },
  //     {
  //       path: "/staff-members/deactivated",
  //       title: "Deactivated Members",
  //       type: "link",
  //     },
  //     // { path: "/staff-member/role", title: "Staff Role", type: "link" },
  //   ],
  // },
  {
    title: "Brands",
    customIcon: true,
    icon: "icofont icofont-shield-alt",
    type: "sub",
    active: false,
    children: [
      { path: "/brands/add", title: "Add Brand", type: "link" },
      { path: "/brands/all", title: "All Brands", type: "link" },
      {
        path: "/brands/activated",
        title: "Activated Brands",
        type: "link",
      },
      {
        path: "/brands/deactivated",
        title: "Deactivated Brands",
        type: "link",
      },
    ],
  },
  {
    title: "Categories",
    customIcon: true,
    icon: "icofont icofont-law-alt-1",
    type: "sub",
    active: false,
    children: [
      { path: "/categories/add", title: "Add Category", type: "link" },
      { path: "/categories/all", title: "All Categories", type: "link" },
      {
        path: "/categories/activated",
        title: "Activated Categories",
        type: "link",
      },
      {
        path: "/categories/deactivated",
        title: "Deactivated Categories",
        type: "link",
      },
    ],
  },
  {
    title: "Products",
    customIcon: true,
    icon: "icofont icofont-bricks",
    type: "sub",
    active: false,
    children: [
      { path: "/products/add", title: "Add Product", type: "link" },
      { path: "/products/all", title: "All Products", type: "link" },
      {
        path: "/products/activated",
        title: "Activated Products",
        type: "link",
      },
      {
        path: "/products/deactivated",
        title: "Deactivated Products",
        type: "link",
      },
    ],
  },
  {
    title: "Banners",
    customIcon: true,
    icon: "icofont icofont-image",
    type: "sub",
    active: false,
    children: [
      { path: "/banners/add", title: "Add Banner", type: "link" },
      { path: "/banners/all", title: "All Banners", type: "link" },
      {
        path: "/banners/activated",
        title: "Activated Banners",
        type: "link",
      },
      {
        path: "/banners/deactivated",
        title: "Deactivated Banners",
        type: "link",
      },
    ],
  },
  {
    title: "Invoices",
    customIcon: true,
    icon: "icofont icofont-files",

    type: "sub",
    active: false,
    children: [
      { path: "/invoices/add", title: "Add Invoice", type: "link" },
      { path: "/invoices/all", title: "All Invoices", type: "link" },
    ],
  },
  {
    title: "Clients",
    customIcon: true,
    icon: "icon-user",
    type: "sub",
    active: false,
    children: [
      {
        path: "/clients/all",
        title: "All Clients",
        type: "link",
      },
      {
        path: "/clients/approved",
        title: "Approved Clients",
        type: "link",
      },
      {
        path: "/clients/disapproved",
        title: "Disapproved Clients",
        type: "link",
      },
    ],
  },
  {
    title: "Enquiries",
    customIcon: true,
    icon: "icon-volume",
    type: "sub",
    active: false,
    children: [
      {
        path: "/enquiries/all",
        title: "All Enquiries",
        type: "link",
      },
      {
        path: "/enquiries/approved",
        title: "Approved Enquiries",
        type: "link",
      },
      {
        path: "/enquiries/disapproved",
        title: "Disapproved Enquiries",
        type: "link",
      },
      //  { path: "/product-brand", title: "All Brand", type: "link" },
    ],
  },
  {
    title: "Contact Us",
    customIcon: true,
    icon: "icon-volume",
    type: "sub",
    active: false,
    children: [
      {
        path: "/contact-us/all",
        title: "All Contact Us",
        type: "link",
      },
      {
        path: "/contact-us/approved",
        title: "Approved Contact Us",
        type: "link",
      },
      {
        path: "/contact-us/disapproved",
        title: "Disapproved Contact Us",
        type: "link",
      },
    ],
  },
  /*{
    title: "Icons",
    customIcon: true,
    icon: "icon-user",
    type: "sub",
    active: false,
    children: [
      {
        path: "/icon/featherIcons",
        title: "Feather",
        type: "link",
      },
      {
        path: "/icon/flagIcons",
        title: "Flag",
        type: "link",
      },
      {
        path: "/icon/fontAwsomeIcon",
        title: "FontAwsome",
        type: "link",
      },
      {
        path: "/icon/icoIcons",
        title: "ICO",
        type: "link",
      },
      {
        path: "/icon/themifyIcons",
        title: "Themify",
        type: "link",
      },
      {
        path: "/icon/weatherIcons",
        title: "Weather",
        type: "link",
      },
    ],
  },
  */
  /**
   * 
      <Route path={`${match.url}featherIcons`} component={featherIcons} />
      <Route path={`${match.url}flagIcons`} component={flagIcons} />
      <Route path={`${match.url}fontAwsomeIcon`} component={fontAwsomeIcon} />
      <Route path={`${match.url}icoIcons`} component={icoIcons} />
      <Route path={`${match.url}themifyIcons`} component={themifyIcons} />
      <Route path={`${match.url}weatherIcons`} component={weatherIcons} />
   */
  {
    title: "Logout",
    icon: LogOut,
    type: "onClick",
    path: "#",
    active: false,
  },
];

export const MENUITEMS_DEALER = [
  {
    title: "Staff Members",
    customIcon: true,
    icon: "icofont icofont-worker",
    type: "sub",
    active: false,
    children: [
      {
        path: "/staff-members/add",
        title: "Add Member",
        type: "link",
      },
      { path: "/staff-members/all", title: "All Members", type: "link" },
      {
        path: "/staff-members/activated",
        title: "Activated Members",
        type: "link",
      },
      {
        path: "/staff-members/deactivated",
        title: "Deactivated Members",
        type: "link",
      },
    ],
  },
  {
    title: "Brands",
    customIcon: true,
    icon: "icofont icofont-shield-alt",
    type: "sub",
    active: false,
    children: [
      { path: "/brands/add", title: "Add Brand", type: "link" },
      { path: "/brands/all", title: "All Brands", type: "link" },
      {
        path: "/brands/activated",
        title: "Activated Brands",
        type: "link",
      },
      {
        path: "/brands/deactivated",
        title: "Deactivated Brands",
        type: "link",
      },
    ],
  },
  {
    title: "Categories",
    customIcon: true,
    icon: "icofont icofont-law-alt-1",
    type: "sub",
    active: false,
    children: [
      { path: "/categories/add", title: "Add Category", type: "link" },
      { path: "/categories/all", title: "All Categories", type: "link" },
      {
        path: "/categories/activated",
        title: "Activated Categories",
        type: "link",
      },
      {
        path: "/categories/deactivated",
        title: "Deactivated Categories",
        type: "link",
      },
    ],
  },
  {
    title: "Products",
    customIcon: true,
    icon: "icofont icofont-bricks",
    type: "sub",
    active: false,
    children: [
      { path: "/products/add", title: "Add Product", type: "link" },
      { path: "/products/all", title: "All Products", type: "link" },
      {
        path: "/products/activated",
        title: "Activated Products",
        type: "link",
      },
      {
        path: "/products/deactivated",
        title: "Deactivated Products",
        type: "link",
      },
    ],
  },
  {
    title: "Banners",
    customIcon: true,
    icon: "icofont icofont-image",
    type: "sub",
    active: false,
    children: [
      { path: "/banners/add", title: "Add Banner", type: "link" },
      { path: "/banners/all", title: "All Banners", type: "link" },
      {
        path: "/banners/activated",
        title: "Activated Banners",
        type: "link",
      },
      {
        path: "/banners/deactivated",
        title: "Deactivated Banners",
        type: "link",
      },
    ],
  },
  {
    title: "Invoices",
    customIcon: true,
    icon: "icofont icofont-files",
    type: "sub",
    active: false,
    children: [
      { path: "/invoices/add", title: "Add Invoice", type: "link" },
      { path: "/invoices/all", title: "All Invoices", type: "link" },
    ],
  },
  {
    title: "Clients",
    customIcon: true,
    icon: "icon-user",
    type: "sub",
    active: false,
    children: [
      {
        path: "/clients/all",
        title: "All Clients",
        type: "link",
      },
      {
        path: "/clients/approved",
        title: "Approved Clients",
        type: "link",
      },
      {
        path: "/clients/disapproved",
        title: "Disapproved Clients",
        type: "link",
      },
    ],
  },
  {
    title: "Enquiries",
    customIcon: true,
    icon: "icon-volume",
    type: "sub",
    active: false,
    children: [
      {
        path: "/enquiries/all",
        title: "All Enquiries",
        type: "link",
      },
      {
        path: "/enquiries/approved",
        title: "Approved Enquiries",
        type: "link",
      },
      {
        path: "/enquiries/disapproved",
        title: "Disapproved Enquiries",
        type: "link",
      },
    ],
  },
  {
    title: "Contact Us",
    customIcon: true,
    icon: Home,
    type: "sub",
    active: false,
    children: [
      {
        path: "/contact-us/all",
        title: "All Contact Us",
        type: "link",
      },
      {
        path: "/contact-us/approved",
        title: "Approved Contact Us",
        type: "link",
      },
      {
        path: "/contact-us/disapproved",
        title: "Disapproved Contact Us",
        type: "link",
      },
    ],
  },
  {
    title: "Logout",
    icon: LogOut,
    type: "onClick",
    path: "#",
    active: false,
  },
];
